import React, {RefObject} from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import NavigationSmallCard from "./navigation_small_card/navigation_small_card";
import TemplateComponent, {TemplateComponentProps} from "../../containers/template_page/template_component/template_component";
import MainParagraph from "../../common_components/main_paragraph/main_paragraph";
import {CardsListData, NavigationCardData} from "../../model/navigation_slider_data";
import ReactDOM from 'react-dom';
import "./c33_navigation_slider_small_card.scss";

class NavigationSliderSmallCard extends TemplateComponent<CardsListData<NavigationCardData>, TemplateComponentProps<CardsListData<NavigationCardData>>> {

    private cardsRefs?: RefObject<any>[];
    private slider: any;

    constructor(props: TemplateComponentProps) {
        super(props);

        this.state = {
            active: 0,
            next: 0,
            slideIndex: 1,
            updateCount: 0
        }
    }


    componentRender(data: CardsListData<NavigationCardData>): React.ReactElement<any> {
        const sliderSettings = {
            dots: false,
            variableWidth: true,
            centerMode: false,
            rows: 1,
            infinite: true,
            arrows: true,
            beforeChange: (currIndex: number, nextIndex: number) => {
                // We cannot change the state, or the rerender won't let the slider component to work properly
                if (this.cardsRefs && this.cardsRefs[nextIndex]) {
                    let nextCard = (ReactDOM.findDOMNode(this.cardsRefs[nextIndex].current) as Element);
                    nextCard.classList.add("active");
                }
            },
            afterChange: (index: number) => {
                this.setState({active: index, next: null, slideIndex: this.state.updateCount + (index + 1)});
            }
        };

        if (!this.cardsRefs) {
            this.cardsRefs = data.cards.map(() => React.createRef());
        }

        return (
            <div className="c33-navigation-slider-small-card auto-margins">
                <MainParagraph title={data.title} text={data.text} />
                <Slider ref={slider => (this.slider = slider)} className="navigation-slider-small-card" {...sliderSettings}>
                    {
                        data.cards.map((cardData: any, index: number) =>
                            <div data-aos="fade-up-left" data-aos-offset="50" key={`card-animation-${index}`}>
                                <NavigationSmallCard key={`card-${index}`} title={cardData.title} text={cardData.text} url={cardData.url} cta={cardData.cta}
                                                  focused={index===this.state.active || index===this.state.next} ref={this.cardsRefs![index]}
                                                  hidden={(!this.state.next || index < this.state.next) && index < this.state.active}/>
                            </div>
                        )
                    }
                </Slider>
                <div className="container-range-slider">
                    <input
                        className="progressive-slider-small-card"
                        onChange={event => this.slider.slickGoTo(event.target.value)}
                        value={this.state.slideIndex}
                        type="range"
                        min="1"
                        max={data.cards.length}
                    />
                </div>
            </div>
        );
    }
}

export default NavigationSliderSmallCard;